import {Grid, Button, Box, Typography} from '@mui/material';
import SvgColor from '../../../components/svg-color';

const MethodButton = ({type, children, ...props}) => {

    let label = ''

    if(type === 'email') label = 'Email'
    if(type === 'mobile') label = 'Celular (SMS)'
    if(type === 'whatsapp') label = 'WhatsApp'

    let icon = null
    if(type === 'email') icon = "/assets/images/icons/email.svg"
    if(type === 'mobile') icon = "/assets/images/icons/mobile.svg"
    if(type === 'whatsapp') icon = "/assets/images/icons/support/whatsapp.svg"

    return(
        <Button 
            sx={{
                borderRadius:2,
                background:(theme) => type === 'email' 
                ? theme.palette.primary.dark 
                : (type === 'whatsapp' ? '#128c7e' : theme.palette.primary.main) ,
                color:'white',
                textTransform:'none',
                //padding:'10px',
                fontSize:'1.2rem',
                fontWeight:600,
                '&:hover':{
                    background:(theme) => type === 'email' 
                    ? theme.palette.primary.dark 
                    : (type === 'whatsapp' ? '#128c7e' : theme.palette.primary.main) ,
                },
                '&:disabled':{
                    opacity:0.15
                }
            }}
            fullWidth
            size='large'
            {...props}
        
        >
            <Grid container alignItems='center'>
                <Grid item>
                    <Box
                        sx={{
                            position:'relative', ml:3,
                            width:32, height:32
                        }}
                    >
                        <SvgColor src={icon} color='#FFF'  sx={{position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)'}}/>
                    </Box>
                    
                </Grid>
                <Grid item xs>
                    <Typography align="center">{label}</Typography>
                </Grid>
            </Grid>
        </Button>
    )
}

export default MethodButton